<template>
	<svg
		id="Group_32150"
		data-name="Group 32150"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="18"
		height="18"
		viewBox="0 0 18 18"
	>
		<defs>
			<clipPath id="clip-path-ExternalLinkSvg">
				<rect id="Rectangle_15029" data-name="Rectangle 15029" width="14" height="14" fill="#5a677d" stroke="#707070" stroke-width="1" />
			</clipPath>
		</defs>
		<g id="Group_32147" data-name="Group 32147">
			<g id="Group_32146" data-name="Group 32146">
				<g id="Group_32148" data-name="Group 32148">
					<rect id="Rectangle_9350" data-name="Rectangle 9350" width="18" height="18" fill="none" />
				</g>
			</g>
			<g id="Mask_Group_290" data-name="Mask Group 290" transform="translate(2.5 2)" clip-path="url(#clip-path-ExternalLinkSvg)">
				<g id="Group_44533" data-name="Group 44533" transform="translate(1.174 -0.415)">
					<path
						id="Path_30438"
						data-name="Path 30438"
						d="M4.9,1.429A1.324,1.324,0,0,0,3.571,2.753V14.934A1.325,1.325,0,0,0,4.9,16.258h9a1.325,1.325,0,0,0,1.324-1.324V9.373a2.648,2.648,0,0,0-2.648-2.648H11.251A1.324,1.324,0,0,1,9.927,5.4V4.077A2.648,2.648,0,0,0,7.279,1.429Zm1.324,9.533a.53.53,0,0,1,.53-.53h5.3a.53.53,0,1,1,0,1.059h-5.3A.53.53,0,0,1,6.219,10.962Zm.53,1.589a.53.53,0,0,0,0,1.059H9.4a.53.53,0,1,0,0-1.059Z"
						transform="translate(-3.571 -1.429)"
						fill="#5a677d"
						fill-rule="evenodd"
					/>
					<path
						id="Path_30439"
						data-name="Path 30439"
						d="M12.353,1.73a3.693,3.693,0,0,1,.9,2.425V5.478a.265.265,0,0,0,.265.265h1.324a3.693,3.693,0,0,1,2.425.9A6.9,6.9,0,0,0,12.353,1.73Z"
						transform="translate(-5.842 -1.506)"
						fill="#5a677d"
					/>
				</g>
			</g>
		</g>
		<g id="Group_32149" data-name="Group 32149" transform="translate(18) rotate(90)">
			<g id="Group_32146-2" data-name="Group 32146">
				<g id="Group_32148-2" data-name="Group 32148">
					<rect id="Rectangle_9350-2" data-name="Rectangle 9350" width="18" height="18" fill="none" />
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ExternalLinkSvg',
};
</script>

<style scoped lang="scss"></style>
